import autosize from "autosize";
import React, { ChangeEvent, forwardRef, RefObject, useEffect, useLayoutEffect, useRef, useState } from "react";
import { TLengthStyledSystem } from "styled-system";
import Input, { InputProps } from "../input/Input";

const Textarea = forwardRef<HTMLTextAreaElement, InputProps>((props, ref) => {
  return <Input py={2} minHeight={20} lineHeight="base" ref={ref} as="textarea" {...props} />;
});

Textarea.displayName = "Textarea";

export default Textarea;

export const ExpandingTextarea = forwardRef<HTMLTextAreaElement, InputProps>(
  ({ minHeight = "32px", onInput, value, ...props }, ref) => {
    const [height, setHeight] = useState<TLengthStyledSystem>(0);
    const ownRef = useRef<HTMLTextAreaElement>(null);
    const textareaRef: RefObject<HTMLTextAreaElement> = (ref || ownRef) as any;
    const isControlled = typeof value !== "undefined";

    const effect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
    effect(() => {
      if (textareaRef.current) {
        setHeight(textareaRef.current.scrollHeight);
      }
    }, [textareaRef]);

    const resizeTextarea = () => {
      if (textareaRef.current) {
        setTimeout(() => {
          setHeight("auto");
          setHeight(textareaRef.current?.scrollHeight || 0);
        }, 0);
      }
    };

    const handleInput = (event: ChangeEvent<any>) => {
      if (!isControlled) {
        resizeTextarea();
      }
      onInput && onInput(event);
    };

    useEffect(() => {
      if (isControlled && textareaRef.current) {
        autosize(textareaRef.current);
      }

      return () => {
        if (textareaRef.current) {
          autosize.destroy(textareaRef.current);
        }
      };
    }, [value]);

    return (
      <Textarea
        rows={1}
        spell={true}
        value={value}
        onInput={handleInput}
        // @ts-ignore
        css={{
          height,
          resize: "none",
          overflow: "hidden",
          minHeight,
          transition: "none",
        }}
        ref={textareaRef}
        {...props}
      />
    );
  },
);

ExpandingTextarea.displayName = "ExpandingTextarea";
